import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

const imageUrls = [
  "https://readdy.ai/api/search-image?query=Clean%20elegant%20fashion%20sneakers%20displayed%20on%20soft%20cream%20textured%20surface%20editorial%20product%20photography%20with%20gentle%20natural%20side%20lighting%20scandinavian%20aesthetic%20simple%20composition%20warm%20neutral%20tones%20premium%20footwear%20isolated%20on%20minimal%20background&width=800&height=1067&seq=catgrid-v2-shoes&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Soft%20cozy%20hoodie%20sweater%20draped%20beautifully%20on%20cream%20textured%20surface%20clean%20editorial%20product%20photography%20gentle%20natural%20lighting%20scandinavian%20minimal%20style%20warm%20neutral%20tones%20relaxed%20casual%20garment%20simple%20elegant%20composition&width=800&height=1067&seq=catgrid-v2-hoodies&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Minimal%20stylish%20cotton%20tshirt%20neatly%20folded%20on%20soft%20cream%20surface%20clean%20editorial%20product%20photography%20natural%20gentle%20side%20light%20scandinavian%20aesthetic%20warm%20neutral%20tones%20basic%20essential%20garment%20simple%20pure%20composition&width=800&height=1067&seq=catgrid-v2-tshirts&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Elegant%20lightweight%20jacket%20displayed%20on%20cream%20textured%20surface%20editorial%20product%20photography%20soft%20natural%20lighting%20scandinavian%20minimal%20style%20warm%20neutral%20tones%20outerwear%20fashion%20piece%20simple%20artistic%20composition&width=800&height=1067&seq=catgrid-v2-jackets&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Well%20tailored%20casual%20trousers%20laid%20flat%20on%20soft%20cream%20surface%20clean%20editorial%20product%20photography%20natural%20gentle%20daylight%20scandinavian%20aesthetic%20warm%20neutral%20tones%20modern%20garment%20simple%20refined%20composition&width=800&height=1067&seq=catgrid-v2-pants&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Stylish%20minimal%20baseball%20cap%20placed%20elegantly%20on%20cream%20textured%20surface%20editorial%20product%20photography%20soft%20natural%20lighting%20scandinavian%20style%20warm%20neutral%20tones%20casual%20accessory%20simple%20clean%20composition&width=800&height=1067&seq=catgrid-v2-headwear&orientation=portrait",
];

export default function CategoryGrid() {
  const { t } = useTranslation();

  const featuredCategories = categories.slice(0, 6);

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-20 bg-background-50">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-14">
        <h2 className="text-3xl md:text-[48px] font-heading font-bold text-foreground-950 whitespace-nowrap">
          {t('feature.title')}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 lg:w-[75%] leading-relaxed">
          {t('feature.desc')}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {featuredCategories.map((cat, idx) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer"
            style={{ aspectRatio: '3/4' }}
          >
            <img
              src={imageUrls[idx]}
              alt={t(cat.nameKey)}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="text-white text-[22px] font-heading font-bold">{t(cat.nameKey)}</h3>
              <p className="text-white/70 text-sm mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {t('feature.shop_now')} →
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}